// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__y0oMY","mini":"IconButton_mini__BRYmT","normal":"IconButton_normal__4cKQ2"};